export default "__VITE_ASSET__SaDVmTxN__"